import { STATUS_META } from "@/lib/constants";

export function StatusChip({ status, testid }) {
  const meta = STATUS_META[status] || { label: status, color: "bg-slate-700 text-slate-200 border-slate-600" };
  return (
    <span
      data-testid={testid || `status-${status}`}
      className={`status-chip border ${meta.color}`}
    >
      {meta.label}
    </span>
  );
}
